import React, { useEffect, useRef, useState } from 'react';
//import PropTypes from 'prop-types';
import Slick from 'react-slick';
import Card from 'components_v2/common/CardV2';
import PrimeScreen from 'components/PrimePaymentFlow/PrimeScreen';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import makeRequest from 'utils/makeRequest';
import PropTypes from 'prop-types';
// import TOI_SUBS_FETCH_PLANS_WEB,
// TOI_SUBS_PLAN_TRANSLATION_WEB,
// 'constants/index';
import Offers from 'components_v2/common/ToipOffers/Offers';
// import { loadNudgeData } from 'reduxUtils/modules/translationConfig';
import {
  checkGracePeriod,
  getPreExpiryFormattedTime,
  checkPreExpireDate,
  checkNewUser,
} from 'utils/primeUtil';
import {
  // loadPaymentSdk,
  handlePlanClick,
} from 'components/ToiSubscription/utils/payment';

import _get from 'lodash.get';
import { connect } from 'react-redux';
import { gaWrapper } from '../../../../../helpers/analytics';
import s from './PrimeSlider.scss';

const PrevArrow = sliderProps => {
  const { className } = sliderProps;
  return (
    <button
      {...sliderProps}
      className={`${s.arrows} ${s.left} ${className}`}
      aria-label="left arrow"
    />
  );
};

const NextArrow = sliderProps => {
  const { className } = sliderProps;
  return (
    <button
      {...sliderProps}
      className={`${s.arrows} ${s.right} ${className}`}
      aria-label="right arrow"
    />
  );
};

const PrimeSlider = props => {
  const [listItems, setSliderList] = useState(null);
  // const [subscriptionRes, setSubscription] = useState(null);
  //const [translationData, setTranslation] = useState(null);
  const [daysRemaining, setDaysRemaining] = useState();
  const [inGracePeriod, setInGracePeriod] = useState(false);
  const [ispreExpired, setIsPreExpired] = useState(false);
  const [userType, setUserType] = useState(null);
  const { data = {}, isPrime = false, country = 'IN', userPrcData } = props;
  const isInitialMount = useRef(true);
  const loadSectionData = () => {
    if (data && !data.dataUrl) {
      return;
    }

    makeRequest.get(data.dataUrl, {}, 'skipfeedengine').then(result => {
      if (result && result.data && result.data.length > 0) {
        setSliderList(result.data);
      }
    });
  };
  // useEffect(() => {
  //   loadPaymentSdk();

  //   const planUrl = `${TOI_SUBS_FETCH_PLANS_WEB}&cc=${
  //     props.country
  //   }&listView=true`;
  //   makeRequest.get(planUrl).then(res => {
  //     if (res?.data?.data) {
  //       console.log('response is', res);
  //       setSubscription(res.data.data);
  //     }
  //   });

  //   const url = `${TOI_SUBS_PLAN_TRANSLATION_WEB}&cc=${props.country}`;

  //   makeRequest.get(url).then(res => {
  //     if (res) {
  //       setTranslation(res);
  //     }
  //   });
  // }, []);

  useEffect(
    () => {
      if (isInitialMount.current) {
        isInitialMount.current = false;
      } else {
        loadSectionData();
      }
    },
    [data && data.dataUrl],
  );

  // useEffect(
  //   () => {
  //     if (props.country) {
  //       props.loadTOIPlusNudgeData(props.isWapView, props.country);
  //     }
  //   },
  //   [props.country],
  // );

  useEffect(
    () => {
      if (userPrcData) {
        getPreExpiryFormattedTime(userPrcData).then(res => {
          setDaysRemaining(res);
        });
        checkGracePeriod(userPrcData).then(res => {
          setInGracePeriod(res);
        });
        checkPreExpireDate(userPrcData).then(res => {
          setIsPreExpired(res);
        });
        checkNewUser(userPrcData).then(res => {
          setUserType(res);
        });
      }
    },
    [userPrcData],
  );

  const handleOfferClick = () => {
    const offer = true;
    const justPayRedirect = false;
    handlePlanClick(
      null,
      // translationData,
      props.userData,
      false,
      props.country,
      null,
      {
        inGracePeriod,
        ispreExpired,
        userType,
        daysRemaining,
        offer,
        justPayRedirect,
      },
    );
  };

  const settings = {
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <NextArrow {...props} />,
    prevArrow: <PrevArrow {...props} />,
    infinite: false,
    dotsClass: s.dots,
  };

  const items = data.items || data.data ? data.items || data.data : listItems;

  const onWidgetClick = (EA, EL) => {
    gaWrapper('send', 'event', `WEB-${country}-NHP1`, EA, EL, {
      nonInteraction: 0,
    });
  };

  if (inGracePeriod && !props.translationNudge?.TOIHPWidget?.grace) {
    return null;
  }
  if (ispreExpired && !props.translationNudge?.TOIHPWidget?.preExpiry) {
    return null;
  }

  return (
    <InViewObserver
      inViewCallback={() => {
        loadSectionData();
      }}
      viewMargin="500px 0px 500px 0px"
    >
      <div
        className={`${s.Toiplus_stories_wrapper} ${
          isPrime ? s.prime_case : ''
        }`}
      >
        <div className="contentwrapper">
          <div className={s.Toiplus_stories}>
            <div className={s.leftcol}>
              <PrimeScreen componentName="HPPrimeInlineWidget" />
            </div>
            <div className={s.rightcol}>
              <div className={s.carousel_toi_widget}>
                <Slick {...settings}>
                  {items instanceof Array
                    ? items.map((item, index) => {
                        item.cs = item.primeid === '100' ? 'prime' : item.cs;
                        return (
                          <div
                            key={item.id || `${item.tn}_${index}`}
                            onClick={() =>
                              onWidgetClick(
                                `click-TOIPlusSection-${index}`,
                                item.wu,
                              )
                            }
                          >
                            <Card data={item} isVerticalTile />
                          </div>
                        );
                      })
                    : null}
                </Slick>
              </div>
            </div>
          </div>

          <div>
            {props.homePageOffers &&
              !isPrime && (
                <Offers
                  pageType="home"
                  homePageOffers={props.homePageOffers}
                  isWapView={false}
                  //subscriptionRes={subscriptionRes}
                  handleOfferClick={handleOfferClick}
                  userData={props.userData}
                />
              )}
          </div>
        </div>
      </div>
    </InViewObserver>
  );
};
// const mapDispatchToProps = dispatch => ({
//   loadTOIPlusNudgeData: (isMobile, countryCode) => {
//     dispatch(loadNudgeData(isMobile, countryCode));
//   },
// });

const mapStateToProps = state => ({
  homePageOffers: _get(
    state.translationConfig.nudges,
    'toidomain.Home.Offers',
    null,
  ),
  userPrcData: state.login.userPrcData,
  translationNudge: _get(state, 'translationConfig.data', {}),
});

PrimeSlider.propTypes = {
  isPrime: PropTypes.bool,
  translationNudge: PropTypes.shape({}),
};
PrimeSlider.defaultProps = {
  isPrime: false,
  translationNudge: {},
};

export default connect(mapStateToProps, null)(PrimeSlider);
